import React from "react";
import { shallowEqual } from "react-redux";
import clsx from "clsx";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "./Summary.module.scss";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import { useTabsContext } from "./SummaryTabsContext";
import InsurancePrice from "../../../common/price/InsurancePrice";
import SummaryTotalOverview from "./SummaryTotalOverview";
import { useCarConfigSelector } from "../../../../../redux/store";
import { pricingDetailsSelector } from "../../../../../utils/selectorUtils";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import { MODAL_INSURANCE_CALCULATOR } from "../../../../../utils/modalConstants";
import { CarConfigConfigureSection } from "../../../../../utils/types/SectionTypes";
import useAphModal from "../../../../../hooks/useAphModal";
import Icon from "../../../../../../shared-components/css-modules/toyota/atoms/Icon";

const SummaryTotals: React.FC = () => {
    const tabsContext = useTabsContext();
    const { hideFinanceDetailsSummaryFooter } = useCarConfigSelector(pricingDetailsSelector, shallowEqual);
    const { showModalHelper } = useAphModal();
    const insuranceQuoteId = useCarConfigSelector((state) => state.finance.quotes.insurance);

    if (tabsContext.openTab === "insurance")
        return (
            <ul role="list" className={styles["config-sublist"]}>
                <li
                    className={clsx(
                        insuranceQuoteId ? styles["config-subitem-total"] : styles["config-subitem-total-button"],
                    )}
                >
                    <Text tag="h3" variant="apheleia-h4">
                        <CarConfigLabel label="carConfigInsuranceTotal" />
                    </Text>

                    {!insuranceQuoteId ? (
                        <Button
                            variant="apheleia-text"
                            className={styles["no-text-underline"]}
                            onClick={() =>
                                showModalHelper(MODAL_INSURANCE_CALCULATOR, { step: CarConfigConfigureSection.Summary })
                            }
                        >
                            <div className={styles["open-finance-calculator"]}>
                                <Icon variant="calculator" sizing="sm" />
                                <CarConfigLabel label="carConfigInsuranceCta" />
                            </div>
                        </Button>
                    ) : (
                        <Text tag="h4" variant="apheleia-h4" className={styles["config-subitem-price"]}>
                            <InsurancePrice />
                        </Text>
                    )}
                </li>
                {insuranceQuoteId && (
                    <li>
                        <div className={styles.disclaimer}>
                            <CarConfigLabel label="carConfigInsuranceTabServicesDisclaimer" />
                        </div>
                    </li>
                )}
            </ul>
        );

    if (!hideFinanceDetailsSummaryFooter && tabsContext.openTab !== "business")
        return (
            <ul role="list" className={styles["config-sublist"]}>
                <li className={styles["config-subitem-total"]}>
                    <SummaryTotalOverview />
                </li>
            </ul>
        );

    // Return null if neither conditions match because we don't want to render
    // anything to keep footer compact
    return null;
};

export default SummaryTotals;
